import { useCallback } from 'react';

import { IReview, MANAGEMENT_REVIEWS } from '@/lib/entities/review';

import { CircleButton } from '@/lib/shared/components/Buttons';
import { ManagementReviewCard } from '@/lib/shared/components/Cards/ManagementReviewCard';
import { H2 } from '@/lib/shared/components/Typography';
import { ArrowIcon } from '@/lib/shared/icons';
import { alignSliderInContainer } from '@/lib/shared/utils/align-slide-in-container';

import { clsx } from 'clsx';
import useEmblaCarousel from 'embla-carousel-react';
import { useTranslation } from 'next-i18next';

import styles from './ManagementReviews.module.scss';

interface IManagementReviews {
  reviews?: IReview[];
}
export const ManagementReviews = ({
  reviews = MANAGEMENT_REVIEWS,
}: IManagementReviews) => {
  const { t } = useTranslation('index', {
    keyPrefix: 'managementPage.reviews',
  });
  const [ref, emblaApi] = useEmblaCarousel({
    align: alignSliderInContainer,
    loop: true,
  });
  const scrollPrev = useCallback(
    () => emblaApi && emblaApi.scrollPrev(),
    [emblaApi]
  );
  const scrollNext = useCallback(
    () => emblaApi && emblaApi.scrollNext(),
    [emblaApi]
  );
  return (
    <div className={styles.reviews}>
      <div className={styles.container}>
        <div className={styles.reviews__top}>
          <H2 className={styles.reviews__title}>{t('title')}</H2>
          <div
            className={clsx(
              styles.reviews__buttons,
              styles['reviews__buttons--desktop']
            )}
          >
            <CircleButton
              name="scroll to previous"
              as={'button'}
              content={<ArrowIcon />}
              styleType={'secondary'}
              theme={'dark'}
              onClick={scrollPrev}
            />
            <CircleButton
              name="scroll to next"
              as={'button'}
              content={<ArrowIcon isRight />}
              styleType={'secondary'}
              theme={'dark'}
              onClick={scrollNext}
            />
          </div>
        </div>
      </div>
      <div ref={ref}>
        <div className={styles.reviews__slides}>
          {reviews.map((r) => (
            <ManagementReviewCard
              {...r}
              key={r.name}
              className={styles.reviews__card}
            />
          ))}
        </div>
      </div>
      <div
        className={clsx(
          styles.reviews__buttons,
          styles['reviews__buttons--mobile']
        )}
      >
        <CircleButton
          name="scroll to previous"
          as={'button'}
          content={<ArrowIcon />}
          styleType={'secondary'}
          theme={'dark'}
          onClick={scrollPrev}
        />
        <CircleButton
          name="scroll to next"
          as={'button'}
          content={<ArrowIcon isRight />}
          styleType={'secondary'}
          theme={'dark'}
          onClick={scrollNext}
        />
      </div>
    </div>
  );
};
